// extracted by mini-css-extract-plugin
export default {"modalPaper":"ExhrLvXuDcYnQ7vP6gGm","modalText":"Kx8sm2RptGeGhUYEibdC","modalTitle":"DwsT8Gnc4nRrGa87hywP","buttonBox":"iWU02WwcTpG_ZfiwjXQj"};